import client from "@irati/utils/services/apollo";
import createCompanyNewsRowMutation from "./mutations/CreateCompanyNewsRow";
import deleteCompanyNewsRowMutation from "./mutations/DeleteCompanyNewsRow";
import updateCompanyNewsTileMutation from "./mutations/UpdateCompanyNewsTile";
import updateHomePageLayoutMutation from "./mutations/UpdateHomePageLayout";
var QUERIES_TO_REFETCH = ["TenantHomePage"];
var HomePage = /** @class */ (function () {
    function HomePage() {
    }
    HomePage.prototype.createCompanyNewsRow = function (variables) {
        return client.mutate({ refetchQueries: QUERIES_TO_REFETCH, mutation: createCompanyNewsRowMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    HomePage.prototype.deleteCompanyNewsRow = function (variables) {
        return client
            .mutate({ awaitRefetchQueries: true, refetchQueries: QUERIES_TO_REFETCH, mutation: deleteCompanyNewsRowMutation, variables: variables })
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    HomePage.prototype.updateCompanyNewsTile = function (variables) {
        return client.mutate({ refetchQueries: QUERIES_TO_REFETCH, mutation: updateCompanyNewsTileMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    HomePage.prototype.updateHomePageLayout = function (variables) {
        return client.mutate({ refetchQueries: QUERIES_TO_REFETCH, mutation: updateHomePageLayoutMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    return HomePage;
}());
var service = new HomePage();
export var createCompanyNewsRow = service.createCompanyNewsRow;
export var deleteCompanyNewsRow = service.deleteCompanyNewsRow;
export var updateCompanyNewsTile = service.updateCompanyNewsTile;
export var updateHomePageLayout = service.updateHomePageLayout;
export default service;
